/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import RFIDInstance from '../../native-interact/RFID';
import RFBluetoothInstance from '../../native-interact/RFBluetooth';
import { runPromiseByQueue, noop, compareVersion, formatDateTime } from '../../js/utils';
import { automatorStore } from '../../mobx/stores/automator';
import { getParkingSpaceByMac, getProRadarBase, getUpgradeInfo, getSerial, getNightMode } from '../../service';
import { getVersion, getWorkState, setWorkState } from '../../service/command';
// import { workModeStore, WORK_MODE } from '../../mobx/stores/work-mode';
import operateConfig from '../../conf/operator';
import { parkStore } from '../../mobx/stores/park';
import { readStore } from '../../mobx/stores/rf';
import { takeOffStore } from '../../mobx/stores/takeoff';
import TakeOffComp from './TakeOff';
import { globalStore } from '../../mobx/stores/global';
import Message from '../../components/message';
import plateExample from '../../assets/imgs/plate-example.jpg';
import plateExample2 from '../../assets/imgs/plate-example2.jpg';
import nativeInterface from '../../native-interact/native';
// import SelectMeter from './SelectMeter';
import { upgradeStore } from '../../mobx/stores/upgrade';
import { stepTime } from '../../mobx/stores/steptime';

const {
  readIMEI,
  readIMSI,
  readICCID,
  readMode
} = RFIDInstance;

const retryCount = 0; // 获取版本号重试次数

// 根据地磁序列号获取车位信息
export function getParkingspaceData() {
  return getParkingSpaceByMac(readStore.RFID).then((data) => {
    const obj = {};

    globalStore.handsetDetectState = data.state === undefined ? null : data.state;

    Object.keys(parkStore.form).forEach((key) => {
      // eslint-disable-next-line no-prototype-builtins
      if (data.hasOwnProperty(key) && data[key] && data[key] !== 'null') {
        if (key === 'abletime') {
          obj[key] = data[key].substr(0, 10);
        } else {
          obj[key] = data[key];
        }
      }
    });

    const form = Object.assign({}, parkStore.form, obj);
    parkStore.form = form;
    console.log('车位信息', parkStore.form);
    return Promise.resolve();
  });
}

function getDevType(cpuType = 'cpu1') {
  const { communicateType, operator } = readStore.projectParam;
  const commType = communicateType.value;
  // cpu1
  if (commType === 'NB') {
    // 将绑定关系更改为配置项
    if (cpuType === 'cpu2') {
      return 'FRANK_CPU2';
    }
    return `FRANK_${operateConfig[parseInt(operator.origin_value, 10)].upgrade_cpu1}_A`;
  }

  if (commType.indexOf('LORA') >= 0) {
    return `FRANK_${commType}_A`;
  }

  return '';
}

function upgradeCPU(resolve, reject) {
  if (upgradeStore.version && upgradeStore.version !== 0) {
    getUpgradeInfo(getDevType('cpu1'), upgradeStore.firmwaretype).then((data) => {
      if (Number(upgradeStore.version) < Number(data.version)) {
        upgradeStore.status = 'default';
        upgradeStore.downloadUrl = data.download_url;
        upgradeStore.MD5 = data.MD5;
        upgradeStore.newVersion = data.version;
        upgradeStore.module = 'cpu1';
        upgradeStore.isRebootCPU1 = false; // 确定CPU1版本不是最新时 初始化CPU1的重启状态为false
        reject(new Error('正在升级CPU1'));
      } else {
        resolve();
      }
    });
    return;
  }
  getVersion('cpu1').then((version) => {
    const versionNumber = version.version.split(' ')[0];
    upgradeStore.firmwaretype = version.firmwaretype;
    upgradeStore.version = versionNumber;
    console.log('cpu1版本号', versionNumber, 'firmwaretype', version.firmwaretype);
    // 获取CPU1最新版本信息
    getUpgradeInfo(getDevType('cpu1'), version.firmwaretype).then((data) => {
      console.log('cpu1最新数据', data);

      if (Number(versionNumber) < Number(data.version)) {
        upgradeStore.status = 'default';
        upgradeStore.downloadUrl = data.download_url;
        upgradeStore.MD5 = data.MD5;
        upgradeStore.newVersion = data.version;
        upgradeStore.module = 'cpu1';
        upgradeStore.isRebootCPU1 = false; // 确定CPU1版本不是最新时 初始化CPU1的重启状态为false
        reject(new Error('正在升级CPU1'));
      } else {
        resolve();
      }

      // if (compareVersion(data.version, version)) {
      //   // 弹窗提供用户选择是否升级或跳过
      //   upgradeStore.downloadUrl = data.download_url;
      //   upgradeStore.MD5 = data.MD5;
      //   upgradeStore.version = version;
      //   upgradeStore.newVersion = data.version;
      //   upgradeStore.module = 'cpu1';
      //   upgradeStore.isRebootCPU1 = false; // 确定CPU1版本不是最新时 初始化CPU1的重启状态为false
      //   reject('upGradeCPU1');
      // } else {
      //   resolve();
      //   // CPU1最新 检测CPU2
      //   // getVersion('cpu2').then((version2) => {
      //   //   console.log('cpu2版本号', version2);
      //   //   getUpgradeInfo(getDevType('cpu2')).then((data2) => {
      //   //     if (compareVersion(data2.version, version2)) {
      //   //       // 弹窗提供用户选择是否升级或跳过
      //   //       upgradeStore.version = version2;
      //   //       upgradeStore.newVersion = data2.version;
      //   //       upgradeStore.module = 'cpu2';
      //   //       reject(new Error('正在升级CPU2'));
      //   //     } else {
      //   //       // 两个CPU均为最新版本 进入下一步
      //   //       resolve();
      //   //     }
      //   //   });
      //   // });
      // }
    }).catch(() => {
      reject(new Error('获取服务器最新版本号错误'));
    });
  }).catch(() => {
    reject(new Error('获取版本号错误'));
  });
}

export const rfidProcess = [
  {
    name: '请放置读卡器',
    abort: '1',
    apply: ['detect', 'install'],
    execute: () => {
      return RFIDInstance.readSerialNo();
    }
  },
  {
    name: '密钥认证',
    abort: '1',
    apply: ['detect', 'install'],
    execute: () => {
      return RFIDInstance.auth();
    }
  },
  {
    name: '获取地磁工作模式',
    abort: '0',
    apply: ['detect', 'install'],
    execute: () => {
      return RFIDInstance.readGeoWorkMode();
    }
  },
  {
    name: '获取车位信息',
    abort: '1',
    apply: ['detect', 'install'],
    execute: () => {
      return getParkingspaceData();
    }
  },
  {
    name: '读取项目参数',
    abort: '1',
    apply: ['detect', 'install'],
    execute: () => {
      return RFIDInstance.readProjectParam().then(({ skip }) => {
        // 获取项目夜间模式配置
        getNightMode({
          serial: readStore.RFID,
          commandType: 1
        }).then((nightModeInfo) => {
          console.log('项目夜间休眠配置', nightModeInfo);
          if (nightModeInfo.commandParam && typeof nightModeInfo.commandParam === 'string') {
            const info = JSON.parse(nightModeInfo.commandParam);
            readStore.nightModeInfo.startTime = info.startTime;
            readStore.nightModeInfo.endTime = info.endTime;
          }
          readStore.nightModeInfo.status = nightModeInfo.status;
          readStore.nightModeInfo.projectId = nightModeInfo.projectId;
        });


        if (!skip) {
          return runPromiseByQueue([
            readIMEI.bind(RFIDInstance),
            readIMSI.bind(RFIDInstance),
            readICCID.bind(RFIDInstance),
            readMode.bind(RFIDInstance)
          ]);
        }
        return Promise.resolve();
      });
    }
  },
  // {
  //   name: '检测是否设置采集器',
  //   abort: '0',
  //   apply: ['install'],
  //   execute: () => {
  //     if (readStore.isLoRa()) {
  //       return new Promise((resolve) => {
  //         const defaultMeter = localStorage.getItem('pre_meter_no') || '';
  //         const msg = (
  //           <SelectMeter onSelect={(data) => { parkStore.meter = data.no; localStorage.setItem('pre_meter_no', data.no); }} defaultMeter={defaultMeter} />
  //         );
  //         Message.confirm(msg, () => {
  //           resolve();
  //         }, () => {
  //           parkStore.meter = '';
  //           resolve();
  //         });
  //       });
  //     }
  //     return Promise.resolve();
  //   }
  // },
  {
    name: '打开地磁蓝牙',
    abort: '1',
    apply: ['detect', 'install'],
    execute: () => {
      return RFIDInstance.openBluetooth();
    }
  },
  {
    name: '蓝牙连接',
    abort: '1',
    apply: ['detect', 'install'],
    execute: () => {
      return RFBluetoothInstance.connectBluetooth();
    }
  },
  // {
  //   name: '非安装模式优先进入安装模式',
  //   abort: '0',
  //   apply: ['detect', 'install'],
  //   execute: () => {
  //     // 成功进入安装模式后 地磁接收蓝牙命令的响应速度会得到提升
  //     console.log('当前地磁工作模式', globalStore.mode);
  //     if (globalStore.mode != 30) {
  //         // 非安装模式提前一步进入安装模式
  //         setWorkState(WORK_MODE.install.mode).then(() => {
  //           workModeStore.status = 'success';
  //           return Promise.resolve();
  //         }).catch((error) => {
  //           console.log('初始进入安装模式失败',error);
  //           workModeStore.status = 'fail';
  //           return Promise.reject(error);
  //         });
  //     }else {
  //       return Promise.resolve();
  //     }
  //   }
  // },
  {
    name: '地磁升级检测中...',
    abort: '1',
    apply: ['detect', 'install'],
    execute: () => {
      //  设置地磁工作模式为安装模式
      console.log('地磁版本初始化检测');
      return new Promise((resolve, reject) => {
        getVersion('cpu1').then((version) => {
          upgradeStore.version = version.version.split(' ')[0];
          upgradeStore.firmwaretype = version.firmwaretype;
          upgradeCPU(resolve, reject);
        }).catch(() => {
          console.log('地磁版本重试检测');
          upgradeCPU(resolve, reject);
        });
      });
      // return new Promise((resolve, reject) => {
      //   // 1、获取地磁CPU1 CPU2版本号 2、对比服务器版本 3、若低于服务器版本判断是否有跳过权限 4、根据最终结果执行下一步 或者弹出升级弹窗
      //   // 查询CPU1当前地磁版本号
      //   // if (globalStore.mode != 30) {
      //   //   // 非安装模式提前一步进入安装模式
      //   //   setWorkState(WORK_MODE.install.mode).then(() => {
      //   //     workModeStore.status = 'success';
      //   //     upgradeCPU(resolve, reject);
      //   //   }).catch((error) => {
      //   //     console.log('初始进入安装模式失败', error);
      //   //     workModeStore.status = 'fail';
      //   //     reject(error);
      //   //   });
      //   // } else {
      //   //   upgradeCPU(resolve, reject);
      //   // }
      //   upgradeCPU(resolve, reject);
      // });
    }
  },
];

const version1 = [
  {
    // 蓝牙连接后，自动调试过程中初始化雷达不能数有其他设备影响初始化值，所以添加拿开读卡器提示
    // eslint-disable-next-line react/jsx-filename-extension
    name: <TakeOffComp store={takeOffStore} />,
    versionExc: '6.92',
    abort: '1',
    apply: ['detect', 'install'],
    execute: () => {
      return new Promise((resolve) => {
        const timer = setInterval(() => {
          if (takeOffStore.skipOver) {
            takeOffStore.count = 20;
            takeOffStore.skipOver = false;
            clearInterval(timer);
            resolve();
          }
          takeOffStore.count -= 1;
          if (takeOffStore.count <= 0) {
            clearInterval(timer);
            // takeOffStore.count = 20;
            resolve();
          }
        }, 1000);
      });
    }
  },
  {
    name: <span>拍摄场地照&nbsp;&nbsp; <a className="take-off-btn" onClick={() => nativeInterface.capture()}>点击拍摄</a></span>,
    type: 'takePhoto',
    abort: '1',
    apply: ['install'],
    execute: function preValidateLocationPhoto() {
      function next(resolve) {
        const msg = (
          <div>
            <p style={{ textAlign: 'left' }}>请确保地磁所在车位区域内无任何杂物及覆盖物，并拍摄一张场地实景照，示例图：</p>
            <img style={{ maxWidth: '200px' }} src={plateExample} alt="示例图" />
          </div>
        );
        Message.alert(msg, () => {
          parkStore.photoState = 1;
          parkStore.on('location_photo_end', () => {
            resolve();
          });
          nativeInterface.capture();
        }, () => {});
      }

      return new Promise((resolve) => {
        if (parkStore.photos.length > 0) {
          if (parkStore.photos.find(item => item.__location_photo__)) {
            resolve();
          } else {
            next(resolve);
          }
        } else {
          next(resolve);
        }
      });
    }
  }
];

const version2 = [
  {
    name: <span>拍摄场地照&nbsp;&nbsp; <a className="take-off-btn" onClick={() => nativeInterface.capture()}>点击拍摄</a></span>,
    type: 'takePhoto',
    abort: '1',
    apply: ['install'],
    execute: function preValidateLocationPhoto() {
      function next(resolve) {
        const msg = (
          <div>
            <p style={{ textAlign: 'left', marginBottom: '15px' }}>请确保拍摄的照片中清晰显示车位号,车位不净空也可安装调试：</p>
            <img style={{ maxWidth: '200px' }} src={plateExample2} alt="示例图" />
          </div>
        );
        Message.alert(msg, () => {
          parkStore.photoState = 1;
          parkStore.on('location_photo_end', () => {
            resolve();
          });
          nativeInterface.capture();
        }, () => {});
      }

      return new Promise((resolve) => {
        if (parkStore.photos.length > 0) {
          if (parkStore.photos.find(item => item.__location_photo__)) {
            resolve();
          } else {
            next(resolve);
          }
        } else {
          next(resolve);
        }
      });
    }
  },
];

const rfidProcessPart2 = [
  {
    // 拍照后快速进入下一步 提示等待地磁进入安装调试模式及请求调试脚本
    // eslint-disable-next-line react/jsx-filename-extension
    name: '正在进入安装调试模式',
    abort: '1',
    apply: ['detect', 'install'],
    execute: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 2000);
      });
    }
  },
];

// 均值/方差计算
function statistic2(data) {
  const num = data.length;
  let total = 0;

  // 均值
  data.forEach((item) => { total += item; });
  const avg = total / num;

  // 方差
  let acc = 0;
  data.forEach((item) => {
    const temp = item - avg;
    acc += temp * temp;
  });
  acc /= num;

  return [avg, acc];
}

// 相关性系数计算
function covariance2(dataX, dataY, count) {
  // eslint-disable-next-line prefer-const
  let [ex, sdx] = statistic2(dataX);
  const [ey, sdy] = statistic2(dataY);

  let exy = 0;
  for (let index = 0; index < count; index++) {
    exy += dataX[index] * dataY[index];
  }
  exy /= count;
  exy -= ex * ey;

  /* 计算相关系数 */
  sdx *= sdy;
  if (sdx <= 1.0e-05) {
    return (0);
  }
  return Math.abs(exy / Math.sqrt(sdx));
}

function storeInstallFail() {
  const data = sessionStorage.getItem('install_fail_radar_base');
  let count = 1;
  if (data) {
    count = JSON.parse(data).count;
    count++;
  }
  sessionStorage.setItem('install_fail_radar_base', JSON.stringify({
    mac: readStore.RFID,
    count
  }));
}

// 比较雷达步骤
const compareRadarBase = {
  name: '比较雷达基值',
  abort: '1',
  execute() {
    return new Promise((resolve, reject) => {
      RFBluetoothInstance.sendCommand('park base', {
        name: '查询当前车位雷达基值',
        expect: 'imsemi'
      }).then((res) => {
        const data = res.match(/^imsemi base:{(.*)}/)[1]
          .trim()
          .split(/\s+/);

        const { version, cfgMagbaseEn, isInitRadar } = globalStore;
        // 大于6.92版本不需要检测雷达值
        // console.log(`cpu1版本${globalStore.version} cfgMagbaseEn值${globalStore.cfgMagbaseEn} ${globalStore.version == '6.92'} ${globalStore.cfgMagbaseEn >= 1}`);
        console.log('是否需要初始化雷达：', isInitRadar, data.length);
        if (Number(version) >= '6.92' || cfgMagbaseEn >= 1) {
          return resolve();
        }
        // 判断标记为是否为1(不需要初始化雷达)、基值和版本较低（不需要校验基值）
        if (data.length < 32 || !/^5\.2.*$|^6\.2.*$/.test(readStore.projectParam.version.value) || isInitRadar) {
          return resolve();
        }

        getProRadarBase(readStore.RFID).then((proData) => {
          if (proData.length > 0) {
            console.log('开始校验生产与现场的雷达基值');

            const covariance = covariance2(proData.map(item => parseInt(item, 10)), data.map(item => parseInt(item, 10)), data.length);
            console.log('相关性系数值：', covariance);
            if (covariance <= 0.9) {
              storeInstallFail();
              return reject(new Error('雷达基值不满足条件(相关性系数)'));
            }
          }

          // 判断k1，k2的值是否满足大于1600并且小于4500
          if ((data[1] < 1600 || data[1] > 4500) && (data[2] < 1700 || data[2] > 4500)) {
            storeInstallFail();
            return reject(new Error('雷达基值不满足条件(k1/k2)'));
          }

          // 判断k10之后的值是否都小于200
          for (let index = 10; index < data.length; index++) {
            if (index <= 16 && data[index] > 500) {
              storeInstallFail();
              return reject(new Error('雷达基值不满足条件(k10+)'));
            }
            if (index > 16 && data[index] > 200) {
              storeInstallFail();
              return reject(new Error('雷达基值不满足条件(k17+)'));
            }
          }

          sessionStorage.removeItem('install_fail_radar_base');
          return resolve();
        }).catch(() => {
          return resolve();
        });
      }).catch(() => {
        return resolve();
      });
    });
  }
};

export function getAutomatorProcess() {
  return automatorStore.getAutoData();
}

export default class Debug {
  constructor(executeFn, options = {}) {
    this.interrupt = false;
    this.executeFn = executeFn || noop;
    this.detectParkingSpace = options.detectParkingSpace;
    this.apply = this.detectParkingSpace ? 'detect' : 'install';
  }

  start() {
    this.interrupt = false;
    const process = rfidProcess.filter(item => item.apply.indexOf(this.apply) !== -1);
    return this.executeProcess(process, 30, 0).then(() => {
      if (this.apply === 'detect') {
        return Promise.resolve();
      }
      // 自动化测试任务需要根据项目参数进行筛选，所以必须等读取完后再匹配自动任务
      return getAutomatorProcess().then((data) => {
        // 判断地磁CPU1 6.92去除移开读卡器提示 去除拍照车位上无异物提示
        const { version } = globalStore;
        let versionProcess = '';
        if (Number(version) >= 6.92) {
          versionProcess = [...version2, ...rfidProcessPart2];
        } else {
          versionProcess = [...version1, ...rfidProcessPart2];
        }
        // console.log(`调试命令 ${JSON.stringify([...versionProcess, ...data, compareRadarBase])}`);
        return this.executeProcess([...versionProcess, ...data, compareRadarBase], 70, 30);
      });
    });
  }

  /**
   * @description 按顺序执行任务
   * @param {array} process 任务合集
   * @param {number} base 当前执行任务合集的基数（用来计算百分比）
   * @param {number} preBase 上一个任务合集的基数
   * @returns
   * @memberof Debug
   */
  executeProcess(process, base, preBase) {
    // console.log(process,base,preBase)
    const promises = process.map(item => item.execute);
    return promises.reduce(
      (
        previousPromise,
        nextPromise,
        index,
        myPromises
      ) => {
        return previousPromise
          .then(() => {
            // console.log(process[index].name, '开始时间: ', formatDateTime(new Date(), 'datetime'));
            stepTime.setStepTime({
              action: process[index].name,
              createtime: new Date().getTime(),
              endtime: '',
              isSuccess: ''
            });
            this.executeFn(process[index], index, promises.length, base, preBase);
            // console.log(index, process[index].name, '开始', formatDateTime(new Date(), 'datetime'));
            if (!this.interrupt) {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve(nextPromise());
                }, 200);
              });
            }

            return Promise.reject(new Error('主动中断操作'));
          })
          .catch((error) => {
            console.log(`调试错误1：${error}---${error instanceof Error}---${typeof error}`);
            // console.log(index, process[index].name, '失败', formatDateTime(new Date(), 'datetime'));
            // console.log(process[index].name, '失败时间: ', formatDateTime(new Date(), 'datetime'));
            stepTime.setStepTime({
              action: process[index].name,
              createtime: '',
              endtime: new Date().getTime(),
              isSuccess: 0
            });
            if (process[index].abort === '1') {
              // 调试步骤失败不可跳过 直接安装失败
              this.stop();
            } else if (!this.interrupt) {
              // 调试步骤失败可跳过 继续安装
              return Promise.resolve();
            }
            myPromises.splice(1);
            // 将安装失败修复建议添加到错误信息返回中
            if (process[index].advice) {
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject({
                advice: process[index].advice,
                error
              });
            }
            return Promise.reject(error);
          });
      },
      Promise.resolve()
    );
  }

  stop() {
    this.interrupt = true;
  }
}
